/**
 * Labstep
 *
 * @module components/File/Action/Delete
 * @desc Action to delete file
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { FileActionDeleteProps } from './types';

export const FileActionDelete: React.FC<FileActionDeleteProps> = ({
  file,
}) =>
  file.parent_type === 'orphan' ? (
    <EntityActionDelete entity={file} />
  ) : null;
